import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  root: {
    width: "auto",
  },
});

class ContentResultRenderer extends Component {
  render() {
    if (!this.props.content) return null;

    const { classes } = this.props;

    const resultRows = this.props.content.map((row, rowIndex) => {
      return (
        <TableRow key={rowIndex}>
          <TableCell>{rowIndex + 1}</TableCell>
          <TableCell>
            {row.map((value, index) => <Typography key={index}>{value.quantity > 1 ? value.quantity + "x " : ""}{value.item}</Typography>)}
          </TableCell>
        </TableRow>
      );
    });

    return (
      <Paper className={classes.root}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Row</TableCell>
              <TableCell>{this.props.contentName}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{resultRows}</TableBody>
        </Table>
      </Paper>
    );
  }
}

ContentResultRenderer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ContentResultRenderer);


// WEBPACK FOOTER //
// ./src/item-helpers/ContentResultRenderer.js